module.exports = __webpack_public_path__ + "static/img/about-company.200b103.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/company/about-company.png
// module id = D0WG
// module chunks = 1